import { mfaInterceptor } from '../../../../reconnect/src/mfa-aspect/infrastructure/interceptor/MFAInterceptor';

import { getRenderer } from './renderModal';

const onReady = (callback: CallableFunction) => {
  let activated = false;
  const protectedCallback = () => {
    if (!activated) {
      activated = true;
      callback();
    }
  };
  const checkReadyState = () =>
    (document.readyState === 'interactive' || document.readyState === 'complete') &&
    protectedCallback();

  document.addEventListener('readystatechange', protectedCallback);
  document.addEventListener('DOMContentLoaded', protectedCallback);
  checkReadyState();
};

onReady(() => {
  if ('Cypress' in window && window.Cypress) return;

  const renderModal = getRenderer();
  mfaInterceptor.initialise();

  mfaInterceptor.onMFARequire((interceptedRequest) => {
    console.log('MFA Required for request:', interceptedRequest);

    renderModal.render({
      onJourneyFinished: () => {
        renderModal.unmount();
      },
      interceptedRequest,
      pendingId: interceptedRequest.getPendingId(),
    });
  });
});
